export function isDevAuthBypassEnabled(): boolean {
  return process.env.NEXT_PUBLIC_DEV_AUTH_BYPASS === '1';
}
